/**
 * Column registry for the Manage Services list.
 *
 * `name` is always rendered (the row's anchor) so it does not appear here.
 * `actions` is also always rendered (View button) and lives outside this set.
 *
 * Default visibility per design decision:
 *   - mode, duration, department, status are on by default
 *   - everything else is opt-in via the Columns menu
 */
export const SERVICE_COLUMNS = [
  { key: "mode", label: "Mode", default: true },
  { key: "duration", label: "Duration", default: true },
  { key: "department", label: "Department", default: true },
  { key: "status", label: "Status", default: true },
  { key: "price", label: "Price", default: false },
  { key: "slot_duration", label: "Slot Duration", default: false },
  { key: "start_buffer", label: "Start Buffer", default: false },
  { key: "end_buffer", label: "End Buffer", default: false },
  { key: "min_time_to_start", label: "Min Time To Start", default: false },
  { key: "order", label: "Order", default: false },
  { key: "followup", label: "Follow-up", default: false },
  { key: "type", label: "Type", default: false },
] as const;

export type ServiceColumnKey = (typeof SERVICE_COLUMNS)[number]["key"];

export const DEFAULT_VISIBLE_COLUMNS: ReadonlySet<ServiceColumnKey> = new Set(
  SERVICE_COLUMNS.filter((c) => c.default).map((c) => c.key)
);
